import React, { useMemo, useState } from "react";
import { MDBBtn, MDBContainer } from "mdb-react-ui-kit";
import { useNavigate } from "react-router-dom";
import ebayLogo from "../assets/marketplaces/ebay.svg";
import shopifyLogo from "../assets/marketplaces/shopify.svg";
import poshmarkLogo from "../assets/marketplaces/poshmark.svg";
import vintedLogo from "../assets/marketplaces/vinted.svg";
import {
  buildOnboardingSteps,
  clearOnboardingJourney,
  saveOnboardingJourney,
} from "../utils/onboardingJourney";

const MARKETPLACES = [
  { id: "shopify", label: "Shopify", logo: shopifyLogo, subtitle: "Instant storefront sync" },
  { id: "ebay", label: "eBay", logo: ebayLogo, subtitle: "Draft + auto publish flow" },
  { id: "poshmark", label: "Poshmark", logo: poshmarkLogo, subtitle: "Browser automation setup" },
  { id: "vinted", label: "Vinted", logo: vintedLogo, subtitle: "Browser automation setup" },
];

function MarketplaceOnboardingPage() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState([]);
  const [submitting, setSubmitting] = useState(false);

  const selectedSet = useMemo(() => new Set(selected), [selected]);

  const toggle = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
    );
  };

  const startFlow = () => {
    const steps = buildOnboardingSteps(selected);
    if (!steps.length) {
      navigate("/dashboard");
      return;
    }
    setSubmitting(true);
    saveOnboardingJourney({
      selected,
      steps,
      currentIndex: 0,
      active: true,
    });
    navigate(steps[0].path);
  };

  const skipForNow = () => {
    clearOnboardingJourney();
    navigate("/dashboard");
  };

  return (
    <MDBContainer fluid className="py-5 px-3" style={{ minHeight: "100vh", background: "#f5f7ff" }}>
      <div className="mx-auto" style={{ maxWidth: "1100px" }}>
        <div className="bg-white rounded-4 border shadow-sm p-4 p-md-5">
          <h2 className="fw-bold mb-2">Connect your marketplaces</h2>
          <p className="text-muted mb-4">
            Select marketplaces you want to configure now. We will guide you step-by-step, and you can skip any step.
          </p>

          <div className="row g-3">
            {MARKETPLACES.map((mp) => (
              <div className="col-12 col-md-6" key={mp.id}>
                <button
                  type="button"
                  onClick={() => toggle(mp.id)}
                  className="w-100 text-start bg-white border rounded-4 p-3 d-flex align-items-center"
                  style={{
                    borderColor: selectedSet.has(mp.id) ? "#2d5bff" : "#dee2e6",
                    borderWidth: selectedSet.has(mp.id) ? 2 : 1,
                  }}
                >
                  <img src={mp.logo} alt={mp.label} style={{ width: 40, height: 40, objectFit: "contain" }} />
                  <div className="ms-3">
                    <div className="fw-semibold">{mp.label}</div>
                    <div className="small text-muted">{mp.subtitle}</div>
                  </div>
                </button>
              </div>
            ))}
          </div>

          <div className="d-flex flex-wrap gap-2 justify-content-end mt-4">
            <MDBBtn color="light" onClick={skipForNow}>
              Skip for now
            </MDBBtn>
            <MDBBtn color="primary" onClick={startFlow} disabled={submitting}>
              Continue setup
            </MDBBtn>
          </div>
        </div>
      </div>
    </MDBContainer>
  );
}

export default MarketplaceOnboardingPage;
